/* PriceInfoSection.tsx generated by @compiled/babel-plugin v0.36.0 */
/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import EditorPanelIcon from '@atlaskit/icon/glyph/editor/panel';
import Tooltip from '@atlaskit/tooltip';
import { BodyNormal, BodySmall, H2 } from '@atlassian/mpac-primitives';
import { editionConstants } from '@atlassian/mpac-utils';
import { TooltipDialog } from '../../common/TooltipDialog';
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
const _11 = "._18u0idpf{margin-left:0}";
const _10 = "._otyridpf{margin-bottom:0}";
const _9 = "._2hwxidpf{margin-right:0}";
const _8 = "._19pkidpf{margin-top:0}";
const _7 = "._syaz1gjq{color:var(--ds-text-subtle,#44546f)}";
const _6 = "._19pk1b66{margin-top:var(--ds-space-050,4px)}";
const _5 = "._zulpv77o{gap:var(--ds-space-025,2px)}";
const _4 = "._4cvr1h6o{align-items:center}";
const _3 = "._2lx21bp4{flex-direction:column}";
const _2 = "._1e0c1txw{display:flex}";
const _ = "._zulpu2gc{gap:var(--ds-space-100,8px)}";
const {
  TEST_IDS
} = editionConstants;
const {
  ACCORDION_PRICING,
  ACCORDION_PRICING_PER_UNIT
} = TEST_IDS;
const priceContainer = null;
const pricePerBilling = null;
const billingCycleTextIconWrapper = null;
const billingCycleText = null;
const priceInfoText = null;
const infoIcon = null;
export const PriceInfoSection = _ref => {
  let {
    priceDetails,
    billingFrequency,
    teamSize,
    lastTierCeiling
  } = _ref;
  const getDuration = () => {
    if (billingFrequency === 'monthlyPricingPlan') return 'per month';
    return 'per year';
  };
  const getPricePerUser = () => {
    if (priceDetails.amount === 0) {
      return "Up to ".concat(priceDetails.currentTierCeiling, " users");
    }
    if (priceDetails.isFlatAmount) {
      return 'Flat fee';
    }
    const pricePerUser = (priceDetails.amount / teamSize).toFixed(2);
    return "USD ".concat(pricePerUser, " per user (average)");
  };
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3]
    }), /*#__PURE__*/_jsx("div", {
      className: ax(["_zulpu2gc _1e0c1txw _2lx21bp4"]),
      children: teamSize > lastTierCeiling ? /*#__PURE__*/_jsxs("div", {
        children: ["The maximum number of users supported is ", lastTierCeiling, ". Try a different team size."]
      }) : /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsxs(CC, {
          children: [/*#__PURE__*/_jsx(CS, {
            children: [_, _2, _4]
          }), /*#__PURE__*/_jsxs("div", {
            className: ax(["_zulpu2gc _1e0c1txw _4cvr1h6o"]),
            children: [/*#__PURE__*/_jsx(H2, {
              as: "div",
              "data-testId": ACCORDION_PRICING,
              children: priceDetails.amount === 0 ? 'Free' : "$".concat(priceDetails.amount.toFixed(2))
            }), priceDetails.amount !== 0 && /*#__PURE__*/_jsxs(CC, {
              children: [/*#__PURE__*/_jsx(CS, {
                children: [_5, _2, _4, _6]
              }), /*#__PURE__*/_jsxs("div", {
                "data-testId": ACCORDION_PRICING_PER_UNIT,
                className: ax(["_zulpv77o _1e0c1txw _4cvr1h6o _19pk1b66"]),
                children: [/*#__PURE__*/_jsxs(CC, {
                  children: [/*#__PURE__*/_jsx(CS, {
                    children: [_7]
                  }), /*#__PURE__*/_jsx(BodySmall, {
                    className: ax(["_syaz1gjq"]),
                    children: getDuration()
                  })]
                }), /*#__PURE__*/_jsx(Tooltip, {
                  component: TooltipDialog,
                  content: "Price shown excludes tax and is calculated progressively using user tier prices",
                  position: "right",
                  children: /*#__PURE__*/_jsxs(CC, {
                    children: [/*#__PURE__*/_jsx(CS, {
                      children: [_2]
                    }), /*#__PURE__*/_jsx("div", {
                      tabIndex: 0,
                      className: ax(["_1e0c1txw"]),
                      children: /*#__PURE__*/_jsx(EditorPanelIcon, {
                        label: "How is app cost calculated?",
                        size: "medium"
                      })
                    })]
                  })
                })]
              })]
            })]
          })]
        }), /*#__PURE__*/_jsxs(CC, {
          children: [/*#__PURE__*/_jsx(CS, {
            children: [_8, _9, _10, _11]
          }), /*#__PURE__*/_jsx(BodyNormal, {
            className: ax(["_19pkidpf _2hwxidpf _otyridpf _18u0idpf"]),
            children: getPricePerUser()
          })]
        })]
      })
    })]
  });
};